import React from 'react';
import * as Scroll from 'react-scroll';
let Linka      = Scroll.Link;

function Navigation() {
    return (
        <>
            <ul>
                <li>
                    <a href="#">
                        Home
                    </a>
                </li>
                <li>
                    <Linka activeClass="active" to="about" spy={true} smooth={true} offset={-50} duration={500}>About Us</Linka>
                </li>
                <li>
                    <Linka activeClass="active" to="contactus" spy={true} smooth={true} offset={50} duration={500}>Contact Us</Linka>
                </li>
            </ul>
        </>
    );
}

export default Navigation;
